// import React, { useState } from "react";
// import "./AssignUserToRole.css";

// function AssignUserToRole() {
//   // input field
//   const [name, setName] = useState("");
//   const [code, setCode] = useState("");
//   const [description, setDescription] = useState("");
//   const [active, setActive] = useState(0);
//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-one">
//         <span className="create-role-heading">Assign User to Role</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn">CANCEL</button>
//           <button className="cr-create-btn" onClick={() => console.log()}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       <div className="create-role-container-two">
//         <div className="create-role-container-two-one">
//           <div>
//             <div style={{ display: "flex", justifyContent: "space-between" }}>
//               <div>
//                 <p className="cr-margin-bottom">Name</p>
//                 <div>
//                   <input
//                     type="text"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     className="create-role-name-field"
//                   />
//                 </div>
//               </div>
//               <div>
//                 <p className="cr-margin-bottom">Code</p>
//                 <div>
//                   <input
//                     type="text"
//                     value={code}
//                     onChange={(e) => setCode(e.target.value)}
//                     className="create-role-code-field"
//                   />
//                 </div>
//               </div>
//             </div>

//             <div>
//               <p className="cr-margin-bottom" style={{ marginTop: "10px" }}>
//                 Description
//               </p>
//               <div>
//                 {/* <input type="text" style={{ width: "100%", height: "10vh" }} /> */}
//                 {/* <textarea name="" id="" cols="84" rows="10"></textarea> */}
//                 <textarea
//                   // style={{ width: "100%", height: "10vh" }}
//                   onChange={(e) => setDescription(e.target.value)}
//                   value={description}
//                   className="create-role-description-field"
//                 ></textarea>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AssignUserToRole;

// ================================================

import React, { useState, useEffect, useRef } from "react";
import "./AssignUserToRole.css";
import SearchBar from "./SearchBar";
import SearchResultsDropdown from "./SearchResultsDropdown";
import EmployeeTable from "./EmployeeTable";
import { FULL_API_BASE_URL } from "../../Config/Config";
import Swal from "sweetalert2";

function AssignUserToRole(dataClient) {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [roleData, setRoleData] = useState([]);

  const [searchResults, setSearchResults] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const [showNameDropdown, setShowNameDropdown] = useState(false);

  const [roleId, setRoleId] = useState(0);

  useEffect(() => {
    fetch(
      // "https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/get-roles/"
      `${FULL_API_BASE_URL}/get-roles/`
    )
      .then((response) => response.json())
      .then((data) => {
        // Adjust according to the actual structure of the response
        setRoleData(data);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  }, []);

  // console.log("dataClient", dataClient.dataClient.client_schema_name[6][0].client_id);

  // -------------------------------------------------------

  function useOutsideAlerter(ref, onOutsideClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          onOutsideClick();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onOutsideClick]);
  }

  const dropdownRef = useRef(null);
  useOutsideAlerter(dropdownRef, () => setShowDropdown(false));

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => setShowNameDropdown(false));

  // -------------------------------------------------------

  const handleNameChange = (event) => {
    // const input = event.target.value;
    // setName(input);
    // const filtered = roleData.filter((role) =>
    //   role.role_name.toLowerCase().includes(input.toLowerCase())
    // );
    // setFilteredRoles(filtered);
    const input = event.target.value;
    setName(input);
    const filtered = roleData.filter((role) =>
      role.role_name.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredRoles(filtered);
    setShowNameDropdown(filtered.length > 0);
  };

  const selectRole = (role) => {
    // setName(role.role_name);
    // setCode(role.role_code);
    // setDescription(role.role_desc);
    // setRoleId(role.role_id);
    // // console.log(role)
    // setFilteredRoles([]); // Clear the search results
    setName(role.role_name);
    setCode(role.role_code);
    setDescription(role.role_desc);
    setRoleId(role.role_id);
    setFilteredRoles([]);
    setShowNameDropdown(false);
  };

  const fetchSearchResults = (searchKey) => {
    // fetch(
    //   // `${FULL_API_BASE_URL}/get-employee-by-search-key/?search_key=${searchKey}`
    //   // `http://3.110.178.2/coaching-collaborator-api/api/v1/get-search-app-user/?search_key=${searchKey}`
    //   `${FULL_API_BASE_URL}/get-search-app-user/?search_key=${searchKey}`
    // )
    //   .then((response) => response.json())
    //   .then((data) => {
    //     setSearchResults(data);
    //     setShowDropdown(true);
    //   })
    //   .catch((error) => console.error("Error fetching search results:", error));
    const trimmedSearchKey = searchKey.trim();

    // Immediately hide the dropdown and clear previous results if the search key is empty
    if (trimmedSearchKey === "") {
      setSearchResults([]); // Assuming setSearchResults is used to manage the state of search results
      setShowDropdown(false); // Assuming setShowDropdown controls the visibility of the dropdown
      return; // Exit the function early to avoid making an unnecessary fetch call
    }

    fetch(
      `${FULL_API_BASE_URL}/get-search-app-user/?search_key=${trimmedSearchKey}`
    )
      .then((response) => response.json())
      .then((data) => {
        setSearchResults(data);
        setShowDropdown(true);
      })
      .catch((error) => {
        console.error("Error fetching search results:", error);
        setShowDropdown(false); // Optionally hide the dropdown on fetch failure
      });
  };

  const handleSelectResult = (employee) => {
    if (
      !selectedEmployees.some((e) => e.staff_number === employee.staff_number)
    ) {
      setSelectedEmployees([
        ...selectedEmployees,
        { ...employee, selected: false },
      ]);
    }
    setShowDropdown(false);
  };

  const handleRemoveSelected = () => {
    setSelectedEmployees(selectedEmployees.filter((e) => !e.selected));
  };

  const onToggleSelected = (index) => {
    const newEmployees = [...selectedEmployees];
    newEmployees[index].selected = !newEmployees[index].selected;
    setSelectedEmployees(newEmployees);
  };

  const handleSave = async () => {
    // console.log("Name:", name);
    // console.log("Code:", code);
    // console.log("Description:", description);
    const selectedIds = selectedEmployees
      .filter((employee) => employee.selected)
      .map((employee) => employee.user_id);
    console.log(JSON.stringify(selectedIds));

    if (!name) {
      // alert("Choose a role");
      Swal.fire({
        title: "Error in assigning user",
        text: "Please fill all the input fields",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    } else if (selectedIds.length == 0) {
      // alert("Insert Users for the Role");
      Swal.fire({
        title: "Error in assigning user",
        text: "Select employees for the Role",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    } else {
      try {
        const user_name =
          dataClient.dataClient.client_schema_name[6][0].user_name;
        const client_id =
          dataClient.dataClient.client_schema_name[6][0].client_id;
        const response = await fetch(
          // `http://3.110.178.2/coaching-collaborator-api/api/v1/new-role?client_id=${1}&role_code=${code}&role_name=${name}&role_desc=${description}d&user_name=${user_name}`,
          `${FULL_API_BASE_URL}/add-role-member?role_id=${roleId}&client_id=${client_id}&created_by=${user_name}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(selectedIds),
          }
        );

        if (response.ok) {
          // alert(`Role Created`);
          Swal.fire({
            title: "Users assigned successfully",
            // text: response.ok,
            icon: "success",
            timer: 2000, // 3 seconds
            confirmButtonColor: "#318682",
          }).then(() => {
            setTimeout(function () {
              window.location.reload();
            }, 100);
          });
        }

        if (!response.ok) {
          // throw new Error(`API request failed with status ${response.status}`);
          Swal.fire({
            title: "Error in assigning users",
            text: `API request failed with status ${response.status}`,
            icon: "error",
            confirmButtonColor: "rgb(100 101 101)",
          });
        }

        const data = await response.json();
        console.log("Data created:", data);
      } catch (error) {
        console.error("Error creating data:", error);
        Swal.fire({
          title: "Error in creating data",
          // text: `${error}`,
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
        // setError(error.message);
      }

      // window.location.reload();
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Cancelled", "Your changes have been cancelled.", "success");
        window.location.reload();
      }
    });
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Assign User to Role</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>

      <div className="create-role-container-two">
        <div className="create-role-container-two-one">
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <div>
                {/* <p className="cr-margin-bottom">Name</p>
                <div>
                  <input
                    type="text"
                    value={name}
                    onChange={handleNameChange}
                    className="create-role-name-field"
                    style={{ padding: "10px", outline: "none" }}
                    // ref={wrapperRef}
                  />
                  <ul className="aur-role-dropdown">
                    {filteredRoles.map((role, index) => (
                      <li
                        key={index}
                        onClick={() => selectRole(role)}
                        className="role-dropdown-item"
                      >
                        {role.role_name}
                      </li>
                    ))}
                  </ul>
                </div> */}
                <p className="cr-margin-bottom">Role</p>
                <div ref={wrapperRef}>
                  <input
                    type="text"
                    value={name}
                    onChange={handleNameChange}
                    onFocus={() =>
                      filteredRoles.length > 0 && setShowNameDropdown(true)
                    }
                    className="create-role-name-field"
                    style={{ padding: "10px", outline: "none" }}
                  />
                  {showNameDropdown && (
                    <ul className="aur-role-dropdown">
                      {filteredRoles.map((role, index) => (
                        <li
                          key={index}
                          onClick={() => selectRole(role)}
                          className="role-dropdown-item"
                        >
                          {role.role_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <div>
                <p className="cr-margin-bottom">Code</p>
                <div>
                  <input
                    type="text"
                    value={code}
                    readOnly
                    className="create-role-code-field"
                    style={{ padding: "10px", outline: "none" }}
                  />
                </div>
              </div>
            </div>

            <div>
              <p className="cr-margin-bottom" style={{ marginTop: "10px" }}>
                Description
              </p>
              <div>
                <textarea
                  readOnly
                  value={description}
                  className="create-role-description-field"
                  style={{ padding: "10px", outline: "none" }}
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "30px" }}>
        <div>
          {/* <button onClick={handleSaveSelected}>Save</button> */}
          <div className="aur-search-removebtn">
            <div ref={dropdownRef}>
              <p style={{ color: "#424342", marginBottom: "6px" }}>
                Add Employee
              </p>
              <SearchBar onSearch={fetchSearchResults} />
              {showDropdown && searchResults.length > 0 && (
                <SearchResultsDropdown
                  results={searchResults}
                  onSelect={handleSelectResult}
                  selectedEmployees={selectedEmployees}
                />
              )}
            </div>
            {selectedEmployees.length !== 0 && (
              <button onClick={handleRemoveSelected} className="aur-removebtn">
                REMOVE SELECTED
              </button>
            )}
          </div>
          <div style={{ marginTop: "13px" }}>
            {selectedEmployees.length > 0 && (
              <EmployeeTable
                employees={selectedEmployees}
                onToggleSelected={onToggleSelected}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssignUserToRole;
